import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import Close from '@mui/icons-material/Close';
import EmailOutlined from '@mui/icons-material/EmailOutlined';
import Facebook from '@mui/icons-material/Facebook';
import Instagram from '@mui/icons-material/Instagram';
import Language from '@mui/icons-material/Language';
import LinkedIn from '@mui/icons-material/LinkedIn';
import LocationOnOutlined from '@mui/icons-material/LocationOnOutlined';
import PhoneOutlined from '@mui/icons-material/PhoneOutlined';
import Public from '@mui/icons-material/Public';
import YouTube from '@mui/icons-material/YouTube';
import { Button, Dialog, IconButton } from '@mui/material';
import { useGetSoftwareIntegratorsQuery } from '@softwareIntegrator/services/softwareIntegrators';
import { ISoftwareIntegratorDto } from '@softwareIntegrator/types/softwareIntegrator';
import { getSpecializationFromSlug } from '@softwareIntegrator/utils/softwareIntegrators';
import { getMarketIcons } from '@event/utils';
import clsx from 'clsx';
import { useCallback, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Map } from '../maps/Map/Map';
import VictronBeam from '@assets/victron-beam.svg?react';

// Intentionally leaving commented code in case the client changes their minds,

/* interface IIntegratorResultProps {
    softwareIntegrator: ISoftwareIntegratorDto;
    onClick: (softwareIntegrator: ISoftwareIntegratorDto) => void;
} */

/* const DROPDOWN_ITEMS: Option[] = [
    { label: 'All markets', value: 'all', icon: AllMarkets },
    {
        label: Markets.OFFGRID_BACKUP,
        value: 'offgrid' as TSoftwareExpertise,
        icon: MARKET_ICONS[Markets.OFFGRID_BACKUP.toLowerCase()].icon,
    },
    {
        label: Markets.ENERGY_STORAGE,
        value: 'consumption' as TSoftwareExpertise,
        icon: MARKET_ICONS[Markets.ENERGY_STORAGE.toLowerCase()].icon,
    },
    {
        label: Markets.PROFESSIONAL_MARINE,
        value: 'professional-marine' as TSoftwareExpertise,
        icon: MARKET_ICONS[Markets.PROFESSIONAL_MARINE.toLowerCase()].icon,
    },
    {
        label: Markets.LEISURE_MARINE,
        value: 'leisure-marine' as TSoftwareExpertise,
        icon: MARKET_ICONS[Markets.LEISURE_MARINE.toLowerCase()].icon,
    },
    {
        label: Markets.PROFESSIONAL_VEHICLES,
        value: 'professional-vehicles' as TSoftwareExpertise,
        icon: MARKET_ICONS[Markets.PROFESSIONAL_VEHICLES.toLowerCase()].icon,
    },
    {
        label: Markets.RECREATIONAL_VEHICLES,
        value: 'recreational-vehicles' as TSoftwareExpertise,
        icon: MARKET_ICONS[Markets.RECREATIONAL_VEHICLES.toLowerCase()].icon,
    },
    {
        label: Markets.INDUSTRIAL,
        value: 'industrial' as TSoftwareExpertise,
        icon: MARKET_ICONS[Markets.INDUSTRIAL.toLowerCase()].icon,
    },
    {
        label: Markets.TELECOM,
        value: 'telecom' as TSoftwareExpertise,
        icon: MARKET_ICONS[Markets.TELECOM.toLowerCase()].icon,
    },
    {
        label: Markets.MOBILITY,
        value: 'mobility' as TSoftwareExpertise,
        icon: MARKET_ICONS[Markets.MOBILITY.toLowerCase()].icon,
    },
]; */

/* const IntegratorResult = ({ softwareIntegrator, onClick }: IIntegratorResultProps) => {
    const { name, country, domain_experience = [] } = softwareIntegrator;

    return (
        <div
            tabIndex={-1}
            onClick={() => onClick(softwareIntegrator)}
            role="button"
            className="flex flex-col lg:flex-row lg:justify-between"
        >
            <div className="lg:w-[40%]">
                <p className="font-museo text-sm">{name}</p>
                <p className="font-museo text-sm text-blog-neutral-600">{`${country.name}`}</p>
            </div>
            <div className="flex gap-3 lg:justify-end items-center grow">
                {domain_experience.map((domain) => {
                    const Icon = MARKET_ICONS[domain.title.toLowerCase()].icon;
                    return <Icon className="w-7" key={domain.id} />;
                })}
            </div>
            <Divider className="mb-4" />
        </div>
    );
}; */

/* const IntegratorResultSection = ({
    results,
    onClickResult,
}: {
    results: ISoftwareIntegratorDto[];
    onClickResult: (softwareIntegrator: ISoftwareIntegratorDto) => void;
}) => {
    return (
        <div className="pr-2">
            <p className="font-museo font-light text-2xl">{results.length} software integrators found</p>
            <div className="flex flex-col mt-8 divide-y divide-neutral-700">
                {results.map((res) => (
                    <div className="py-2">
                        <IntegratorResult softwareIntegrator={res} key={res.id} onClick={() => onClickResult(res)} />
                    </div>
                ))}
            </div>
        </div>
    );
}; */

export const MapDialog = ({
    open,
    integrator,
    onClose,
    onMarkerButtonClick,
    onContactButtonClick,
}: {
    open: boolean;
    onClose: () => void;
    integrator: ISoftwareIntegratorDto | null;
    onMarkerButtonClick: (integrator: ISoftwareIntegratorDto) => void;
    onContactButtonClick: (integrator: ISoftwareIntegratorDto) => void;
}) => {
    /* const [showMobileDropdown, setShowMobileDropdown] = useState(false); */
    /* const [selectedOption, setSelectedOption] = useState(DROPDOWN_ITEMS[0].value); */
    /* const [searchQuery, setSearchQuery] = useState<string | undefined>(); */
    /* const [selectedIntegrator, setSelectedIntegrator] = useState<ISoftwareIntegratorDto | null>(null); */

    /* const isLargeOrLarger = useMediaQuery(theme.breakpoints.up('lg')); */

    /* const debouncedSearchQuery = useDebounce({ value: searchQuery, delay: 300 }); */

    const { data } = useGetSoftwareIntegratorsQuery({
        /* search: debouncedSearchQuery,
        domain_experience:
            selectedOption === DROPDOWN_ITEMS[0].value ? undefined : (selectedOption as TSoftwareExpertise), */
    });

    const intl = useIntl();
    const marketIcons = getMarketIcons(intl);

    /* const softwareIntegrators = useMemo(() => data?.results ?? [], [data]); */

    const { facebook, instagram, linkedin, youtube } = useMemo(() => {
        return { ...integrator?.socials };
    }, [integrator?.socials]);

    const showSocials = useMemo(
        () => Boolean(facebook) || Boolean(linkedin) || Boolean(instagram) || Boolean(youtube),
        [facebook, instagram, linkedin, youtube]
    );

    const handleClose = useCallback(
        (e: object, reason: string) => {
            if (reason === 'backdropClick') {
                return;
            }
            /*
                setTimeout(() => {
                setSearchQuery(undefined);
                setSelectedOption(DROPDOWN_ITEMS[0].value);
                setSelectedIntegrator(null);
            }, 100); */
            onClose?.();
        },
        [onClose]
    );

    const handleContactButton = useCallback(() => {
        if (integrator) {
            // Maybe add back this call if you want the map modal to close after closing the contact modal, but we'll need separate states
            // onClose();
            onContactButtonClick(integrator);
        }
    }, [integrator, onContactButtonClick]);

    const handleCopyButtonFactory = useCallback(
        (integrator: ISoftwareIntegratorDto | null) => () => {
            if (integrator) {
                const { name, city, country, contact_email, phone } = integrator;

                // Use regex to clear extra blank lines
                const text = `
                    ${name}
                    :pushpin: ${city}, ${country.name}
                    ${contact_email ? `:email: ${contact_email}` : ''}
                    ${phone ? `:telephone_receiver: ${phone}` : ''}
                `.replace(/^\s*[\r\n]/gm, '');

                navigator.clipboard.writeText(text);
            }
        },
        []
    );

    /* const handleClickResult = useCallback((result: ISoftwareIntegratorDto) => setSelectedIntegrator(result), []); */

    /* const handleBackClick = useCallback(() => setSelectedIntegrator(null), []); */

    /* const renderValue = useCallback((maybeValue: unknown) => {
        if (maybeValue) {
            const value = maybeValue as string;
            const selectedOption = DROPDOWN_ITEMS.find((option) => option.value === value);
            if (selectedOption) {
                const Icon = selectedOption.icon as NonNullable<Option['icon']>;
                return (
                    <div className="flex gap-4">
                        <div className="w-[24px] aspect-square">
                            <Icon className="h-full w-full" />
                        </div>
                        <span className="tracking-wider text-base"> {selectedOption.label}</span>
                    </div>
                );
            }
        }
        return <div className="flex gap-2">{DROPDOWN_ITEMS[0].label}</div>;
    }, []); */

    return (
        <Dialog
            open={open}
            disableEscapeKeyDown
            onClose={handleClose}
            slotProps={{
                paper: {
                    className: 'w-full sm:w-auto rounded-2xl p-4 lg:flex min-h-[80vh] lg:min-w-[60vw]',
                },
            }}
        >
            <div className="text-right">
                <IconButton onClick={(e) => handleClose(e, '')}>
                    <Close />
                </IconButton>
            </div>
            <div
                className={clsx('grid grid-cols-1 gap-y-4 gap-x-20 lg:grid-cols-2 lg:p-4', {
                    'lg:grid-rows-[auto_auto_auto_50vh]': false,
                    'lg:grid-rows-[1fr_auto] grow': Boolean(integrator),
                })}
            >
                {false ? (
                    <>
                        {/* <div className="lg:col-start-1 lg:row-span-1 h-fit">
                            <p className="font-roboto text-blog-neutral-600 text-base">SOFTWARE INTEGRATOR PROGRAM</p>
                            <p className="font-museo font-light text-2xl capitalize">
                                Find authorised software integrators
                            </p>
                        </div>
                        <div className="flex col-start-1 row-start-2 justify-between items-center h-fit">
                            <Search
                                placeholder="Search location or developer"
                                className="lg:w-full"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                            <IconButton onClick={() => setShowMobileDropdown((prev) => !prev)} className="lg:hidden">
                                <TuneIcon />
                            </IconButton>
                        </div>
                        {(isLargeOrLarger || showMobileDropdown) && (
                            <div className="col-start-1 row-start-3 h-fit">
                                <Select
                                    items={DROPDOWN_ITEMS}
                                    type="default"
                                    renderValue={renderValue}
                                    value={selectedOption}
                                    onChange={(e) => setSelectedOption(e.target.value as string)}
                                    className="w-64 h-10"
                                />
                            </div>
                        )}
                        <div className="col-start-1 row-start-5 lg:row-start-4 lg:overflow-y-auto">
                            <IntegratorResultSection results={softwareIntegrators} onClickResult={handleClickResult} />
                        </div> */}
                    </>
                ) : (
                    <>
                        <div className="overflow-y-auto max-h-[calc(70vh-64px)]">
                            <div className="bg-[#F5F5F5] p-4">
                                {/* <Button
                                    variant="text"
                                    color="black"
                                    onClick={handleBackClick}
                                    className="px-0 font-medium"
                                >
                                    <ArrowBack className="mr-2" />
                                    <span>Back to results</span>
                                </Button> */}
                                <div className="flex justify-between items-center my-4">
                                    <p className="font-museo text-2xl ">
                                        {integrator?.name === integrator?.contact_name
                                            ? `${integrator?.name}`
                                            : `${integrator?.name} - ${integrator?.contact_name}`}
                                    </p>
                                    <IconButton onClick={handleCopyButtonFactory(integrator)}>
                                        <AssignmentOutlinedIcon />
                                    </IconButton>
                                </div>

                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 gap-x-4 mt-6">
                                    {integrator?.city && (
                                        <div className="flex gap-4 items-center">
                                            <LocationOnOutlined />
                                            <span className="font-museo font-light text-sm">{integrator.city}</span>
                                        </div>
                                    )}
                                    {integrator?.contact_email && (
                                        <div className="flex gap-4 items-center">
                                            <EmailOutlined />
                                            <a
                                                href={`mailto: ${integrator.contact_email}`}
                                                className="font-museo font-light text-sm text-spanish-blue"
                                                target="_blank"
                                            >
                                                {integrator.contact_email}
                                            </a>
                                        </div>
                                    )}
                                    {integrator?.phone && (
                                        <div className="flex gap-4 items-center">
                                            <PhoneOutlined />
                                            <span className="font-museo font-light text-sm">{integrator.phone}</span>
                                        </div>
                                    )}
                                    {integrator?.website && (
                                        <div className="flex gap-4 items-center">
                                            <Language />
                                            <a
                                                href={
                                                    integrator.website?.match(/^(https?:|mailto:|tel:)/i)
                                                        ? integrator.website
                                                        : `https://${integrator.website}`
                                                }
                                                target="_blank"
                                                rel="noopener"
                                                className="font-museo font-light text-sm text-spanish-blue"
                                            >
                                                {integrator.website}
                                            </a>
                                        </div>
                                    )}
                                    {Boolean(integrator?.languages_spoken.length) && (
                                        <div className="flex gap-4 items-center">
                                            <Public />
                                            <span className="font-museo font-light text-sm">
                                                {integrator?.languages_spoken.join(' / ')}
                                            </span>
                                        </div>
                                    )}
                                </div>
                                {showSocials && (
                                    <div className="mt-8">
                                        <p className="font-museo">
                                            <FormattedMessage id="common.socials" defaultMessage="Socials" />
                                        </p>
                                        <div className="flex gap-2 mt-1">
                                            {instagram && (
                                                <IconButton
                                                    className="p-0"
                                                    component={'a'}
                                                    href={instagram}
                                                    target="_blank"
                                                >
                                                    <Instagram />
                                                </IconButton>
                                            )}
                                            {facebook && (
                                                <IconButton
                                                    className="p-0"
                                                    component={'a'}
                                                    href={facebook}
                                                    target="_blank"
                                                >
                                                    <Facebook />
                                                </IconButton>
                                            )}
                                            {youtube && (
                                                <IconButton
                                                    className="p-0"
                                                    component={'a'}
                                                    href={youtube}
                                                    target="_blank"
                                                >
                                                    <YouTube />
                                                </IconButton>
                                            )}
                                            {linkedin && (
                                                <IconButton
                                                    className="p-0"
                                                    component={'a'}
                                                    href={linkedin}
                                                    target="_blank"
                                                >
                                                    <LinkedIn />
                                                </IconButton>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                            {Boolean(integrator?.software_specializations.length) && (
                                <div className="mt-8 px-4">
                                    <p className="font-museo font-semibold text-xl mb-4">
                                        <FormattedMessage
                                            id="softwareIntegrator.softwareSpecializations"
                                            defaultMessage="Software Specializations"
                                        />
                                    </p>
                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                        {integrator?.software_specializations.map((item) => {
                                            const { icon: Icon, title } = getSpecializationFromSlug(item);
                                            return (
                                                <div key={item} className="font-museo font-light text-sm">
                                                    <div className="flex gap-4">
                                                        <div className="w-[24px] aspect-square">
                                                            <Icon className="h-full w-full" />
                                                        </div>
                                                        <span className="font-museo font-light text-sm">{title}</span>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                            {Boolean(integrator?.domain_experience.length) && (
                                <div className="mt-8 px-4">
                                    <p className="font-museo font-semibold text-xl mb-4">
                                        <FormattedMessage
                                            id="softwareIntegrator.ourExperience"
                                            defaultMessage="Our Expertise"
                                        />
                                    </p>
                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                        {integrator?.domain_experience.map((item) => {
                                            const Icon = marketIcons[item.slug]?.icon ?? VictronBeam;
                                            return (
                                                <div className="flex gap-4">
                                                    <div className="w-[24px] aspect-square">
                                                        <Icon className="h-full w-full" />
                                                    </div>
                                                    <span className="font-museo font-light text-sm">{item.title}</span>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="flex mt-auto gap-4 h-fit lg:row-start-4 px-4">
                            <Button
                                component={'a'}
                                className="rounded-full flex-auto"
                                href={
                                    integrator?.website?.match(/^(https?:|mailto:|tel:)/i)
                                        ? integrator.website
                                        : integrator?.website
                                        ? `https://${integrator.website}`
                                        : undefined
                                }
                                rel="noopener"
                                disabled={!Boolean(integrator?.website)}
                                target="_blank"
                            >
                                <FormattedMessage id="common.website" defaultMessage="Website" />
                            </Button>
                            <Button
                                className="rounded-full flex-auto"
                                disabled={!Boolean(integrator?.contact_email)}
                                onClick={handleContactButton}
                            >
                                <FormattedMessage id="common.contact" defaultMessage="Contact" />
                            </Button>
                        </div>
                    </>
                )}

                <div
                    className={clsx(
                        'min-h-[400px] row-start-4 lg:min-h-auto lg:col-start-2 lg:row-start-1 lg:row-span-4',
                        { 'hidden lg:block': Boolean(integrator) }
                    )}
                >
                    <Map
                        integrators={data?.results ?? []}
                        onMarkerButtonClick={onMarkerButtonClick}
                        zoom={7}
                        center={{ lat: integrator?.latitude ?? 0, lng: integrator?.longitude ?? 0 }}
                    />
                </div>
            </div>
        </Dialog>
    );
};
